import { Text, type Field } from '@sitecore-jss/sitecore-jss-nextjs';
import AlertBanner, {
  type AlertBannerProps,
} from 'components/authorable/general/AlertBanner/AlertBanner';
import EditingHelpText from 'components/helpers/EditingHelpText';
import type { SocialEmbedNetwork } from 'lib/util/social-embed';

type SummaryPanelProps = {
  isVisible: boolean;
  provider: SocialEmbedNetwork | null;
  fields?: {
    src?: Field<string>;
    accessibilityTitle?: Field<string>;
  };
};

const SummaryPanel = ({ isVisible, provider, fields }: SummaryPanelProps): JSX.Element => {
  const missingNetworkAlert = {
    fields: {
      alertType: {
        fields: {
          Value: {
            value: 'Danger',
          },
        },
      },
      alertText: {
        value:
          'Could not detect social network.  Please verify you have entered a valid social post url.',
      },
      isAlertImage: {
        value: false,
      },
    },
  } as unknown as AlertBannerProps;

  return (
    <div data-testid="social-embed-ee-summary" className={isVisible ? 'block' : 'hidden'}>
      <EditingHelpText
        text="Social Embed | Inline edit the fields below or update values in the data source."
        block
      />
      {provider ? (
        <div>
          <strong>Detected Network:</strong> {provider}
        </div>
      ) : (
        <AlertBanner {...missingNetworkAlert} />
      )}
      <div>
        <strong>Embed URL:</strong>
        <Text field={fields?.src ?? { value: '' }} tag="span" />
      </div>
      <div>
        <strong>Accessibility Title:</strong>
        <Text field={fields?.accessibilityTitle ?? { value: '' }} tag="span" />
      </div>
    </div>
  );
};

export default SummaryPanel;
